import { render, staticRenderFns } from "./add-customer.vue?vue&type=template&id=da088ab4&scoped=true"
import script from "./add-customer.vue?vue&type=script&lang=js"
export * from "./add-customer.vue?vue&type=script&lang=js"
import style0 from "./add-customer.vue?vue&type=style&index=0&id=da088ab4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da088ab4",
  null
  
)

export default component.exports